import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  input,
  output,
  signal,
  effect,
  inject,
} from '@angular/core';
// FikoYTRequestService: CLAUDE.md Utility Haritası'nda listelenen shared/services servisi.
import { FikoYTRequestService } from '@/src/app/shared/services/fikoyt-request.service';
// SoyAgaciService: kisiDetayVeIliskilerCek metodu zaten mevcut; kisiDetayCekFn sağlanmadığında fallback olarak kullanılır.
import { SoyAgaciService } from '@/src/app/uygulamalar/soyagaci/services/soy-agaci.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { escapeRegex } from '@/src/app/shared/utils/regex.utils';
import { IYuzBbox, IKisiBalonVeri, IKisiBalonIliski } from '@/src/app/shared/interfaces/yuz.interfaces';
export type { IKisiBalonVeri, IKisiBalonIliski } from '@/src/app/shared/interfaces/yuz.interfaces';

@Component({
  selector: 'kisi-balon-v2',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, NzIconModule, NzButtonModule, NzDividerModule, NzTooltipModule],
  template: `
    <div class="kb" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">

      @if (duzenleModu()) {
        <!-- Duzenleme Modu -->
        <div class="kb-duzenle-header">
          <span nz-icon nzType="edit" nzTheme="outline" class="kb-duzenle-ikon"></span>
          <span class="kb-duzenle-baslik">{{ kisi().kisiIsmi }}</span>
        </div>
        <div class="kb-body">
          <input class="kb-duzenle-input" placeholder="Kisi adi..." [(ngModel)]="aramaMetni"
                 (ngModelChange)="kisiAra($event)" (keydown.enter)="duzenleKaydet.emit({ ismi: aramaMetni })" autofocus />
          @if (aramaSonuclari().length) {
            <div class="kb-arama-sonuclar">
              @for (sonuc of aramaSonuclari(); track sonuc._id) {
                <div class="kb-arama-sonuc" (click)="duzenleKaydet.emit(sonuc)">
                  @if (sonuc.kaynak === 'soyagaci' && sonuc.resimUrl) {
                    <img [src]="sonuc.resimUrl" class="kb-arama-avatar" />
                  } @else if (sonuc.kaynak === 'soyagaci') {
                    <span class="kb-arama-harf kb-arama-aile">{{ (sonuc.ismi || '?').charAt(0) }}</span>
                  } @else {
                    <img [src]="fapiUrl() + '/fikoyt.com.FikoYT.sistem.kullanici.' + sonuc._id + '.profilResmi?boyut=40x?'" class="kb-arama-avatar" />
                  }
                  <span class="kb-arama-isim">{{ sonuc.ismi }}</span>
                  @if (sonuc.kaynak === 'soyagaci') {
                    <span class="kb-arama-rozet">Aile</span>
                  }
                </div>
              }
            </div>
          }
          <div class="kb-duzenle-bar">
            <button class="kb-duzenle-btn kb-kaydet" (click)="duzenleKaydet.emit({ ismi: aramaMetni })">Kaydet</button>
            <button class="kb-duzenle-btn kb-iptal" (click)="duzenleIptal.emit()">Iptal</button>
          </div>
        </div>
      } @else {

        <!-- ======== HEADER ======== -->
        <div class="kb-header"
             [class.kb-kadin]="kisiCinsiyet === 'F' || kisiCinsiyet === 'K'"
             [class.kb-vefat]="kisiDetay()?.vefatEtti"
             [class.kb-soyagaci]="kisi().soyagaciKisiId && !kisi().kisiId && kisiCinsiyet !== 'F' && kisiCinsiyet !== 'K'">

          <!-- Dekoratif daireler -->
          <div class="kb-header-deko kb-deko-1"></div>
          <div class="kb-header-deko kb-deko-2"></div>

          <!-- Kapat butonu -->
          <button class="kb-kapat" (click)="kapat.emit()" nz-tooltip nzTooltipTitle="Kapat">
            <span nz-icon nzType="close" nzTheme="outline"></span>
          </button>

          <div class="kb-profil">
            <div class="kb-avatar-ring"
                 [class.kb-ring-kadin]="kisiCinsiyet === 'F' || kisiCinsiyet === 'K'"
                 [class.kb-ring-vefat]="kisiDetay()?.vefatEtti">
              <div class="kb-avatar-inner">
                <span class="kb-avatar-harf">{{ basHarf }}</span>
                @if (kisi().kisiId && !kisi().soyagaciKisiId) {
                  <img class="kb-avatar-img" [src]="fapiUrl() + '/fikoyt.com.FikoYT.sistem.kullanici.' + kisi().kisiId + '.profilResmi?boyut=120x?'"
                    (error)="$any($event.target).style.display='none'" />
                }
                @if (kisi().resimUrl || kisiDetay()?.resimUrl) {
                  <img class="kb-avatar-img" [src]="kisi().resimUrl || kisiDetay()?.resimUrl"
                    (error)="$any($event.target).style.display='none'" style="z-index:2;" />
                }
              </div>
              @if (kisiDetay()?.vefatEtti) {
                <div class="kb-vefat-simge">🕊</div>
              }
            </div>

            <div class="kb-isim-alan">
              <h3 class="kb-isim">{{ kisi().kisiIsmi }}</h3>
              @if (kisiDetay()?.meslek) {
                <span class="kb-altbaslik">{{ kisiDetay().meslek }}</span>
              }
              <div class="kb-rozetler">
                @if (kisi().soyagaciKisiId) {
                  <span class="kb-rozet kb-rozet-aile">
                    <span nz-icon nzType="apartment" nzTheme="outline"></span> Aile
                  </span>
                }
                @if (kisi().kisiId) {
                  <span class="kb-rozet kb-rozet-uye">
                    <span nz-icon nzType="user" nzTheme="outline"></span> Uye
                  </span>
                }
                @if (!kisi().soyagaciKisiId && !kisi().kisiId) {
                  <span class="kb-rozet kb-rozet-etiket">
                    <span nz-icon nzType="tag" nzTheme="outline"></span> Etiket
                  </span>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- ======== SEKMELER ======== -->
        <div class="kb-tabs">
          <button class="kb-tab" [class.aktif]="sekme() === 'bilgi'" (click)="sekme.set('bilgi')">
            <span nz-icon nzType="idcard" nzTheme="outline"></span> Bilgi
          </button>
          @if (kisi().soyagaciKisiId || kisi().kisiId) {
            <button class="kb-tab" [class.aktif]="sekme() === 'iliskiler'" (click)="sekme.set('iliskiler')">
              <span nz-icon nzType="team" nzTheme="outline"></span> Bag
              @if (iliskiler().length) {
                <span class="kb-tab-sayi">{{ iliskiler().length }}</span>
              }
            </button>
          }
          <button class="kb-tab" [class.aktif]="sekme() === 'islemler'" (click)="sekme.set('islemler')">
            <span nz-icon nzType="appstore" nzTheme="outline"></span> Islem
          </button>
        </div>

        <!-- ======== BILGI ======== -->
        @if (sekme() === 'bilgi') {
          <div class="kb-icerik">
            @if (yukleniyor()) {
              <div class="kb-yukle">
                <div class="kb-yukle-cizgi"></div>
                <div class="kb-yukle-cizgi kb-yukle-kisa"></div>
                <div class="kb-yukle-cizgi kb-yukle-orta"></div>
              </div>
            } @else if (kisiDetay(); as det) {
              @if (det.dogumTarihi || det.dogumYeri) {
                <div class="kb-bilgi-satir">
                  <div class="kb-bilgi-ikon-wrap">
                    <span nz-icon nzType="gift" nzTheme="outline" class="kb-bilgi-ikon"></span>
                  </div>
                  <div class="kb-bilgi-icerik">
                    <span class="kb-bilgi-etiket">Dogum</span>
                    <span class="kb-bilgi-deger">{{ det.dogumTarihi }}@if(det.dogumYeri){ · {{ det.dogumYeri }}}</span>
                  </div>
                </div>
              }
              @if (det.vefatEtti && (det.vefatTarihi || det.olumTarihi)) {
                <div class="kb-bilgi-satir">
                  <div class="kb-bilgi-ikon-wrap kb-ikon-vefat">
                    <span nz-icon nzType="clock-circle" nzTheme="outline" class="kb-bilgi-ikon"></span>
                  </div>
                  <div class="kb-bilgi-icerik">
                    <span class="kb-bilgi-etiket">Vefat</span>
                    <span class="kb-bilgi-deger">{{ det.vefatTarihi || det.olumTarihi }}</span>
                  </div>
                </div>
              }
              @if (det.meslek) {
                <div class="kb-bilgi-satir">
                  <div class="kb-bilgi-ikon-wrap kb-ikon-meslek">
                    <span nz-icon nzType="tool" nzTheme="outline" class="kb-bilgi-ikon"></span>
                  </div>
                  <div class="kb-bilgi-icerik">
                    <span class="kb-bilgi-etiket">Meslek</span>
                    <span class="kb-bilgi-deger">{{ det.meslek }}</span>
                  </div>
                </div>
              }
              @if (det.cinsiyet) {
                <div class="kb-bilgi-satir">
                  <div class="kb-bilgi-ikon-wrap" [class.kb-ikon-kadin]="det.cinsiyet === 'F' || det.cinsiyet === 'K'">
                    <span nz-icon [nzType]="(det.cinsiyet === 'F' || det.cinsiyet === 'K') ? 'woman' : 'man'" nzTheme="outline" class="kb-bilgi-ikon"></span>
                  </div>
                  <div class="kb-bilgi-icerik">
                    <span class="kb-bilgi-etiket">Cinsiyet</span>
                    <span class="kb-bilgi-deger">{{ (det.cinsiyet === 'F' || det.cinsiyet === 'K') ? 'Kadin' : 'Erkek' }}</span>
                  </div>
                </div>
              }
              @if (!det.dogumTarihi && !det.dogumYeri && !det.meslek && !det.cinsiyet && !(det.vefatEtti)) {
                <div class="kb-bos">
                  <span nz-icon nzType="file-unknown" nzTheme="outline" class="kb-bos-ikon"></span>
                  <span class="kb-bos-metin">Detay bilgisi girilmemis</span>
                </div>
              }
            } @else if (!kisi().soyagaciKisiId && !kisi().kisiId) {
              <div class="kb-bos">
                <span nz-icon nzType="tag" nzTheme="outline" class="kb-bos-ikon"></span>
                <span class="kb-bos-metin">Sadece isim etiketi</span>
                <span class="kb-bos-alt">{{ kisi().kisiIsmi }}</span>
              </div>
            } @else {
              <div class="kb-bos">
                <span nz-icon nzType="file-unknown" nzTheme="outline" class="kb-bos-ikon"></span>
                <span class="kb-bos-metin">Bilgi bulunamadi</span>
              </div>
            }
          </div>
        }

        <!-- ======== ILISKILER ======== -->
        @if (sekme() === 'iliskiler') {
          <div class="kb-icerik kb-iliski-scroll">
            @if (iliskiler().length) {
              @for (b of iliskiler(); track b.karsiId) {
                <div class="kb-iliski" (click)="iliskiTiklandi.emit(b.karsiId)">
                  <div class="kb-iliski-avatar" [class.kb-iliski-kadin]="b.cinsiyet === 'F' || b.cinsiyet === 'K'">
                    @if (b.avatarUrl) {
                      <img [src]="b.avatarUrl" (error)="$any($event.target).style.display='none'" />
                    } @else {
                      <span class="kb-iliski-harf">{{ b.basHarf || '?' }}</span>
                    }
                  </div>
                  <div class="kb-iliski-metin">
                    <span class="kb-iliski-isim">{{ b.isim }}</span>
                    <span class="kb-iliski-tur"><span [style.color]="b.renk">{{ b.simge }}</span> {{ b.tur }}</span>
                  </div>
                  <span nz-icon nzType="right" nzTheme="outline" class="kb-iliski-ok"></span>
                </div>
              }
            } @else {
              <div class="kb-bos">
                <span nz-icon nzType="disconnect" nzTheme="outline" class="kb-bos-ikon"></span>
                <span class="kb-bos-metin">Iliski bulunamadi</span>
              </div>
            }
          </div>
        }

        <!-- ======== ISLEMLER ======== -->
        @if (sekme() === 'islemler') {
          <div class="kb-icerik">
            <div class="kb-aksiyonlar">
              @if (duzenlenebilir()) {
                <button class="kb-aksiyon" (click)="duzenlemeBaslat()">
                  <div class="kb-aksiyon-ikon kb-aksiyon-turuncu"><span nz-icon nzType="edit" nzTheme="outline"></span></div>
                  <span>Duzenle</span>
                </button>
              }
              @if (silinebilir()) {
                <button class="kb-aksiyon" (click)="etiketSil.emit(kisi().id)">
                  <div class="kb-aksiyon-ikon kb-aksiyon-kirmizi"><span nz-icon nzType="delete" nzTheme="outline"></span></div>
                  <span>Sil</span>
                </button>
              }
            </div>
          </div>
        }

        <!-- ======== ALT NAVIGASYON ======== -->
        @if (kisi().soyagaciKisiId || kisi().kisiId) {
          <div class="kb-footer">
            <button class="kb-footer-btn" (click)="soyAgacinaGitTiklandi()">
              <span nz-icon nzType="apartment" nzTheme="outline"></span> Soy Agaci
            </button>
            <div class="kb-footer-ayrac"></div>
            <button class="kb-footer-btn" (click)="kisiSayfasinaGitTiklandi()">
              <span nz-icon nzType="idcard" nzTheme="outline"></span> Kisi Sayfasi
            </button>
          </div>
        }
      }
    </div>
  `,
  styles: [`
    :host { display: block; }

    /* ── Kart ── */
    .kb {
      width: 240px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      box-shadow:
        0 4px 6px -1px rgba(0,0,0,0.07),
        0 10px 15px -3px rgba(0,0,0,0.1),
        0 20px 50px -12px rgba(0,0,0,0.2);
      animation: kb-giris 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    @keyframes kb-giris {
      from { opacity: 0; transform: scale(0.92) translateY(8px); }
      to   { opacity: 1; transform: scale(1) translateY(0); }
    }

    /* ── Header ── */
    .kb-header {
      position: relative;
      padding: 12px 12px 10px;
      background: linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%);
      overflow: hidden;
    }
    .kb-kadin  { background: linear-gradient(135deg, #4a0e2e 0%, #be185d 50%, #f472b6 100%); }
    .kb-vefat  { background: linear-gradient(135deg, #1f2937 0%, #4b5563 50%, #9ca3af 100%); }
    .kb-soyagaci { background: linear-gradient(135deg, #052e16 0%, #15803d 50%, #4ade80 100%); }

    .kb-header-deko {
      position: absolute;
      border-radius: 50%;
      background: rgba(255,255,255,0.06);
      pointer-events: none;
    }
    .kb-deko-1 { width: 120px; height: 120px; top: -40px; right: -20px; }
    .kb-deko-2 { width: 80px; height: 80px; bottom: -30px; left: -20px; }

    .kb-kapat {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: none;
      background: rgba(255,255,255,0.12);
      color: rgba(255,255,255,0.7);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      transition: all 0.2s;
      z-index: 3;
      backdrop-filter: blur(4px);
    }
    .kb-kapat:hover { background: rgba(255,255,255,0.25); color: #fff; transform: scale(1.1); }

    .kb-profil {
      display: flex;
      align-items: center;
      gap: 10px;
      position: relative;
      z-index: 2;
    }

    .kb-avatar-ring {
      position: relative;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      padding: 2px;
      background: linear-gradient(135deg, rgba(255,255,255,0.5), rgba(255,255,255,0.15));
      flex-shrink: 0;
    }
    .kb-ring-kadin { background: linear-gradient(135deg, #fda4af, #f472b6); }
    .kb-ring-vefat { background: linear-gradient(135deg, #d1d5db, #6b7280); }

    .kb-avatar-inner {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
      position: relative;
      background: rgba(255,255,255,0.1);
    }
    .kb-avatar-harf {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 800;
      color: rgba(255,255,255,0.85);
      text-transform: uppercase;
    }
    .kb-avatar-img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
    .kb-vefat-simge {
      position: absolute;
      bottom: -2px;
      right: -2px;
      font-size: 11px;
      filter: drop-shadow(0 1px 2px rgba(0,0,0,0.3));
    }

    .kb-isim-alan {
      flex: 1;
      min-width: 0;
    }
    .kb-isim {
      margin: 0;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .kb-altbaslik {
      display: block;
      color: rgba(255,255,255,0.6);
      font-size: 9px;
      margin-top: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .kb-rozetler {
      display: flex;
      gap: 3px;
      margin-top: 4px;
      flex-wrap: wrap;
    }
    .kb-rozet {
      display: inline-flex;
      align-items: center;
      gap: 2px;
      padding: 1px 6px;
      border-radius: 20px;
      font-size: 8px;
      font-weight: 600;
      letter-spacing: 0.2px;
      backdrop-filter: blur(8px);
    }
    .kb-rozet-aile  { background: rgba(74,222,128,0.2); color: #bbf7d0; border: 1px solid rgba(74,222,128,0.2); }
    .kb-rozet-uye   { background: rgba(96,165,250,0.2); color: #bfdbfe; border: 1px solid rgba(96,165,250,0.2); }
    .kb-rozet-etiket { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.6); border: 1px solid rgba(255,255,255,0.1); }

    /* ── Sekmeler ── */
    .kb-tabs {
      display: flex;
      padding: 0 8px;
      background: #fafbfc;
      border-bottom: 1px solid #f1f5f9;
    }
    .kb-tab {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 3px;
      padding: 6px 3px 4px;
      border: none;
      background: none;
      font-size: 10px;
      font-weight: 500;
      color: #94a3b8;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      transition: all 0.2s;
      font-family: inherit;
      position: relative;
    }
    .kb-tab:hover { color: #64748b; }
    .kb-tab.aktif {
      color: #2563eb;
      font-weight: 600;
      border-bottom-color: #2563eb;
    }
    .kb-tab-sayi {
      background: #dbeafe;
      color: #2563eb;
      font-size: 9px;
      font-weight: 700;
      padding: 1px 5px;
      border-radius: 10px;
      min-width: 16px;
      text-align: center;
      line-height: 1.4;
    }

    /* ── Icerik Ortak ── */
    .kb-icerik {
      padding: 6px 10px 8px;
    }

    /* ── Yukleme Iskeleti ── */
    .kb-yukle { display: flex; flex-direction: column; gap: 10px; padding: 6px 0; }
    .kb-yukle-cizgi {
      height: 12px;
      border-radius: 6px;
      background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
      background-size: 200% 100%;
      animation: kb-parlama 1.5s ease infinite;
    }
    .kb-yukle-kisa { width: 60%; }
    .kb-yukle-orta { width: 80%; }
    @keyframes kb-parlama {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }

    /* ── Bilgi Satirlari ── */
    .kb-bilgi-satir {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 5px 0;
      border-bottom: 1px solid #f8fafc;
      animation: kb-satir-giris 0.2s ease both;
    }
    .kb-bilgi-satir:last-child { border-bottom: none; }
    @keyframes kb-satir-giris {
      from { opacity: 0; transform: translateX(-8px); }
      to   { opacity: 1; transform: translateX(0); }
    }
    .kb-bilgi-satir:nth-child(2) { animation-delay: 0.05s; }
    .kb-bilgi-satir:nth-child(3) { animation-delay: 0.1s; }
    .kb-bilgi-satir:nth-child(4) { animation-delay: 0.15s; }

    .kb-bilgi-ikon-wrap {
      width: 24px;
      height: 24px;
      border-radius: 6px;
      background: #eff6ff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    .kb-bilgi-ikon { font-size: 11px; color: #3b82f6; }
    .kb-ikon-vefat  { background: #f3f4f6; }
    .kb-ikon-vefat .kb-bilgi-ikon { color: #6b7280; }
    .kb-ikon-meslek { background: #f0fdf4; }
    .kb-ikon-meslek .kb-bilgi-ikon { color: #22c55e; }
    .kb-ikon-kadin  { background: #fdf2f8; }
    .kb-ikon-kadin .kb-bilgi-ikon { color: #ec4899; }

    .kb-bilgi-icerik {
      display: flex;
      flex-direction: column;
      min-width: 0;
    }
    .kb-bilgi-etiket {
      font-size: 8px;
      font-weight: 600;
      color: #94a3b8;
      text-transform: uppercase;
      letter-spacing: 0.4px;
    }
    .kb-bilgi-deger {
      font-size: 11px;
      font-weight: 500;
      color: #1e293b;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /* ── Bos Durum ── */
    .kb-bos {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px 8px;
      gap: 2px;
    }
    .kb-bos-ikon { font-size: 18px; color: #cbd5e1; }
    .kb-bos-metin { font-size: 10px; color: #94a3b8; font-weight: 500; }
    .kb-bos-alt { font-size: 11px; color: #475569; font-weight: 600; margin-top: 1px; }

    /* ── Iliskiler ── */
    .kb-iliski-scroll { max-height: 140px; overflow-y: auto; padding: 4px 10px 8px; }
    .kb-iliski-scroll::-webkit-scrollbar { width: 3px; }
    .kb-iliski-scroll::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 3px; }

    .kb-iliski {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 4px 6px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.15s;
      animation: kb-satir-giris 0.2s ease both;
    }
    .kb-iliski:hover { background: #f8fafc; transform: translateX(2px); }

    .kb-iliski-avatar {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      flex-shrink: 0;
      overflow: hidden;
      border: 2px solid #e2e8f0;
      background: linear-gradient(135deg, #3b82f6, #6366f1);
    }
    .kb-iliski-kadin { border-color: #f9a8d4; }
    .kb-iliski-avatar img { width: 100%; height: 100%; object-fit: cover; }
    .kb-iliski-harf {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 12px;
      font-weight: 700;
    }
    .kb-iliski-metin { flex: 1; min-width: 0; display: flex; flex-direction: column; }
    .kb-iliski-isim {
      font-size: 11px;
      font-weight: 600;
      color: #1e293b;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .kb-iliski-tur { font-size: 9px; color: #94a3b8; }
    .kb-iliski-ok { font-size: 10px; color: #cbd5e1; transition: transform 0.15s; }
    .kb-iliski:hover .kb-iliski-ok { transform: translateX(2px); color: #94a3b8; }

    /* ── Aksiyonlar ── */
    .kb-aksiyonlar {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 6px;
    }
    .kb-aksiyon {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      padding: 8px 4px 6px;
      border: 1px solid #f1f5f9;
      border-radius: 10px;
      background: #fafbfc;
      font-size: 9px;
      font-weight: 600;
      color: #475569;
      cursor: pointer;
      transition: all 0.2s;
      font-family: inherit;
      animation: kb-satir-giris 0.2s ease both;
    }
    .kb-aksiyon:hover {
      background: #fff;
      border-color: #dbeafe;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(37,99,235,0.1);
    }
    .kb-aksiyon:active { transform: translateY(0); }
    .kb-aksiyon-ikon {
      width: 26px;
      height: 26px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      background: linear-gradient(135deg, #eff6ff, #dbeafe);
      color: #2563eb;
      transition: transform 0.2s;
    }
    .kb-aksiyon:hover .kb-aksiyon-ikon { transform: scale(1.08); }
    .kb-aksiyon-yesil   { background: linear-gradient(135deg, #f0fdf4, #dcfce7); color: #16a34a; }
    .kb-aksiyon-mor     { background: linear-gradient(135deg, #f5f3ff, #ede9fe); color: #7c3aed; }
    .kb-aksiyon-turuncu { background: linear-gradient(135deg, #fff7ed, #ffedd5); color: #ea580c; }
    .kb-aksiyon-kirmizi { background: linear-gradient(135deg, #fef2f2, #fecaca); color: #dc2626; }

    /* ── Duzenleme ── */
    .kb-duzenle-header {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 14px;
      background: linear-gradient(135deg, #0f172a 0%, #1e40af 100%);
      color: #fff;
      font-size: 13px;
      font-weight: 600;
    }
    .kb-duzenle-ikon { font-size: 14px; opacity: 0.6; }
    .kb-duzenle-baslik { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

    .kb-duzenle-input {
      width: 100%;
      padding: 8px 12px;
      border: 1.5px solid #e2e8f0;
      border-radius: 10px;
      font-size: 13px;
      font-family: inherit;
      outline: none;
      transition: all 0.2s;
      box-sizing: border-box;
      background: #f8fafc;
    }
    .kb-duzenle-input:focus { border-color: #3b82f6; background: #fff; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }

    .kb-arama-sonuclar { max-height: 150px; overflow-y: auto; margin-top: 8px; }
    .kb-arama-sonuc {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 8px;
      border-radius: 8px;
      cursor: pointer;
      transition: background 0.12s;
    }
    .kb-arama-sonuc:hover { background: #f1f5f9; }
    .kb-arama-avatar { width: 26px; height: 26px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
    .kb-arama-harf {
      width: 26px; height: 26px; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-size: 11px; font-weight: 700; color: #fff;
      background: linear-gradient(135deg, #3b82f6, #6366f1);
      flex-shrink: 0;
    }
    .kb-arama-aile { background: linear-gradient(135deg, #22c55e, #16a34a); }
    .kb-arama-isim { font-size: 12px; font-weight: 500; color: #1e293b; flex: 1; }
    .kb-arama-rozet { font-size: 9px; font-weight: 600; color: #22c55e; margin-left: auto; }

    .kb-duzenle-bar { display: flex; gap: 6px; margin-top: 10px; }
    .kb-duzenle-btn {
      flex: 1;
      padding: 7px 10px;
      border: none;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      font-family: inherit;
      transition: all 0.15s;
    }
    .kb-kaydet { background: linear-gradient(135deg, #22c55e, #16a34a); color: #fff; }
    .kb-kaydet:hover { filter: brightness(1.08); transform: translateY(-1px); }
    .kb-iptal  { background: #f1f5f9; color: #64748b; }
    .kb-iptal:hover { background: #e2e8f0; }

    .kb-body { padding: 8px 10px 10px; }

    /* ── Footer Navigasyon ── */
    .kb-footer {
      display: flex;
      align-items: center;
      border-top: 1px solid #f1f5f9;
      background: #fafbfc;
      border-radius: 0 0 12px 12px;
    }
    .kb-footer-btn {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 7px 6px;
      border: none;
      background: none;
      font-size: 10px;
      font-weight: 600;
      color: #475569;
      cursor: pointer;
      transition: all 0.15s;
      font-family: inherit;
    }
    .kb-footer-btn:hover { color: #2563eb; background: #eff6ff; }
    .kb-footer-btn:first-child { border-radius: 0 0 0 12px; }
    .kb-footer-btn:last-child  { border-radius: 0 0 12px 0; }
    .kb-footer-btn:active { transform: scale(0.97); }
    .kb-footer-btn span[nz-icon] { font-size: 12px; }
    .kb-footer-ayrac {
      width: 1px;
      height: 16px;
      background: #e2e8f0;
      flex-shrink: 0;
    }
  `],
})
export class KisiBalonV2Component implements OnDestroy {
  // kisiDetayCekFn callback verilmediğinde SoyAgaciService.kisiDetayVeIliskilerCek kullanılır (mevcut utility)
  private soyAgaci = inject(SoyAgaciService);

  // Inputs
  readonly kisi = input.required<IKisiBalonVeri>();
  readonly silinebilir = input(false);
  readonly duzenlenebilir = input(false);
  readonly duzenleModu = input(false);
  readonly resimUrl = input('');

  // Callback inputs (service bağımlılıkları yerine)
  readonly fapiUrl = input('');
  readonly aktifKullaniciId = input('');
  readonly kisiDetayCekFn = input<((kisiId: string) => Promise<{ kisiDetay: any; iliskiler: IKisiBalonIliski[] }>) | undefined>();
  readonly kisiyeGitFn = input<((kisiId: string, tip: 'soyagaci' | 'profil' | 'agac') => void) | undefined>();

  // Outputs
  readonly kapat = output<void>();
  readonly etiketSil = output<string>();
  readonly iliskiTiklandi = output<string>();
  readonly duzenleKaydet = output<any>();
  readonly duzenleIptal = output<void>();

  // State
  readonly sekme = signal<'bilgi' | 'iliskiler' | 'islemler'>('bilgi');
  readonly kisiDetay = signal<any>(null);
  readonly iliskiler = signal<IKisiBalonIliski[]>([]);
  readonly yukleniyor = signal(false);
  readonly aramaSonuclari = signal<any[]>([]);

  aramaMetni = '';
  private aramaTimer: any = null;

  get basHarf(): string { return (this.kisi().kisiIsmi || '?').charAt(0).toUpperCase(); }
  get kisiCinsiyet(): string | null { return this.kisiDetay()?.cinsiyet || null; }

  constructor() {
    effect(() => {
      const k = this.kisi();
      if (this.duzenleModu()) {
        this.aramaMetni = k.kisiIsmi || '';
      }
      if (k.soyagaciKisiId) {
        this.detayCek(k.soyagaciKisiId);
      } else if (k.kisiId) {
        this.detayCek(k.kisiId);
      }
    });
  }

  duzenlemeBaslat() {
    this.aramaMetni = this.kisi().kisiIsmi || '';
    this.aramaSonuclari.set([]);
    this.duzenleKaydet.emit({ _duzenlemeBaslat: true });
  }

  async kisiAra(metin: string) {
    if (this.aramaTimer) clearTimeout(this.aramaTimer);
    if (!metin || metin.length < 2) {
      this.aramaSonuclari.set([]);
      return;
    }
    this.aramaTimer = setTimeout(async () => {
      try {
        const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.goUyeler.aggregate' });
        istek.parametreler = {
          aggregate: [
            { $match: { 'veri.pilesmi': { $regex: escapeRegex(metin), $options: 'i' } } },
            { $limit: 5 },
            { $project: { _id: 1, 'veri.pilesmi': 1 } }
          ]
        };
        await istek.isteSync();
        const platform = (istek.cevap?.sonuc || []).map((k: any) => ({
          _id: k._id, ismi: k.veri?.pilesmi || k._id, kaynak: 'platform',
        }));

        let soyagaci: any[] = [];
        try {
          const soyIstek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.aggregate' });
          soyIstek.parametreler = {
            aggregate: [
              { $match: { vt: 'FikoYT.sistem.soyAgaciKisiler', silindi: { $ne: true },
                $or: [
                  { 'veri.isim': { $regex: escapeRegex(metin), $options: 'i' } },
                  { 'veri.soyIsim': { $regex: escapeRegex(metin), $options: 'i' } },
                ]
              }},
              { $limit: 5 },
              { $project: { _id: 1, 'veri.isim': 1, 'veri.soyIsim': 1, 'veri.resimUrl': 1 } }
            ]
          };
          await soyIstek.isteSync();
          soyagaci = (soyIstek.cevap?.sonuc || []).map((k: any) => ({
            _id: 'soyagaci:' + k._id, soyagaciKisiId: k._id,
            ismi: ((k.veri?.isim || '') + ' ' + (k.veri?.soyIsim || '')).trim(),
            resimUrl: k.veri?.resimUrl, kaynak: 'soyagaci',
          }));
        } catch {}

        this.aramaSonuclari.set([...soyagaci, ...platform]);
      } catch {
        this.aramaSonuclari.set([]);
      }
    }, 300);
  }

  private async detayCek(kisiId: string): Promise<void> {
    const fn = this.kisiDetayCekFn();
    this.yukleniyor.set(true);
    try {
      // kisiDetayCekFn verilmişse onu kullan, yoksa SoyAgaciService.kisiDetayVeIliskilerCek (mevcut utility) ile çek
      const { kisiDetay, iliskiler } = fn
        ? await fn(kisiId)
        : await this.soyAgaci.kisiDetayVeIliskilerCek(kisiId);
      this.kisiDetay.set(kisiDetay);
      this.iliskiler.set(iliskiler || []);
    } catch {
    } finally {
      this.yukleniyor.set(false);
    }
  }

  kisiSayfasinaGitTiklandi(): void {
    const k = this.kisi();
    const hedefId = k.soyagaciKisiId || k.kisiId;
    if (!hedefId) return;
    this.kapat.emit();
    const fn = this.kisiyeGitFn();
    if (fn) {
      if (k.soyagaciKisiId || /^[a-f0-9]{24}$/i.test(hedefId)) {
        fn(hedefId, 'soyagaci');
      } else {
        fn(hedefId, 'profil');
      }
    }
  }

  ngOnDestroy(): void {
    if (this.aramaTimer) { clearTimeout(this.aramaTimer); this.aramaTimer = null; }
  }

  soyAgacinaGitTiklandi(): void {
    const k = this.kisi();
    const odakId = k.soyagaciKisiId || k.kisiId;
    if (!odakId) return;
    this.kapat.emit();
    const fn = this.kisiyeGitFn();
    if (fn) fn(odakId, 'agac');
  }
}
